module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "horse__content"
  }, [_c('vue-audio', {
    ref: "horseRun",
    attrs: {
      "file": 8,
      "loop": true
    }
  }), _vm._v(" "), _c('vue-audio', {
    ref: "raceTextGoal",
    attrs: {
      "file": 9
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "horse",
    class: _vm.status + ' horse-0' + _vm.horseData.color,
    attrs: {
      "id": _vm.id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5776add6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Horse.vue
// module id = 80
// module chunks = 0